import React, { useEffect, useState } from "react";
import { MessageCircle, Sparkles } from "lucide-react";
import { WHATSAPP_URL } from "../mock";

const MobileBottomBar = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`lg:hidden fixed inset-x-0 bottom-0 z-40 transition-transform duration-300 ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="mx-3 mb-3 rounded-2xl border border-white/10 bg-[#0e1626]/95 backdrop-blur shadow-2xl shadow-black/40 px-2.5 py-2.5 flex items-center gap-2">
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noreferrer"
          className="flex-1 inline-flex items-center justify-center gap-2 h-11 rounded-xl border border-emerald-500/40 bg-emerald-500/10 text-emerald-200 text-[13.5px] font-medium"
        >
          <MessageCircle className="h-4 w-4" /> WhatsApp
        </a>
        <a
          href="#apply"
          className="flex-[1.4] inline-flex items-center justify-center gap-2 h-11 rounded-xl bg-red-500 hover:bg-red-600 text-white text-[13.5px] font-semibold shadow-lg shadow-red-500/25"
        >
          <Sparkles className="h-4 w-4" /> Apply Free →
        </a>
      </div>
    </div>
  );
};

export default MobileBottomBar;
